export const findAudioDeviceByLabel = (
  audioDevices?: [string, MediaDeviceInfo][],
  label?: string
) => {
  if (!label) return undefined;

  return audioDevices?.find((pair) => pair?.[1]?.label === label)?.[1];
};
